import ProdutoModel from 'models/Produto';
import ProdutoCategoria from 'models/ProdutoCategoria';
import { useEffect, useState } from 'react';
import {
  FaBuilding,
  FaEdit,
  FaTimesCircle,
  FaCamera,
  FaInfoCircle,
} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import {
  Row,
  Modal,
  Button,
  Card,
  CardBody,
  Form,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  CardHeader,
  Table,
  Col,
  Label,
} from 'reactstrap';
import api from 'services/api';
import ModalUploadImagem from 'components/ModalUploadImagem';
import Compress from 'compress.js';
import OpcaoMostrarBotoes from 'staticData/OpcaoMostrarBotoes';
import {
  Checkbox,
  FormControlLabel,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import Select from 'react-select';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';

interface ProdutoAssociado {
  produtoRelacao: {
    id: number;
    nome: string;
  };
}

interface Props {
  produtos: ProdutoModel[];
  produtoCategorias: ProdutoCategoria[];
  carregaProdutos: () => void;
}

export default function ListaProdutos({
  produtos,
  produtoCategorias,
  carregaProdutos,
}: Props): JSX.Element {
  const [formModalState, setFormModalState] = useState(false);
  const [produtoEditing, setProdutoEditing] = useState({} as ProdutoModel);
  const [produtoSelecionado, setProdutoSelecionado] = useState<ProdutoModel>();
  const [exibirModalImagem, setExibirModalImagem] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [opcaoMostrarBotoes, setOpcaoMostrarBotoes] = useState('4');
  const [produtosSelecao, setProdutosSelecao] = useState<any[]>([]);
  const [produtosAssociadosIniciais, setProdutosAssociadosIniciais] = useState<
    ProdutoModel[]
  >([]);
  const [produtosAssociados, setProdutosAssociados] = useState({} as any);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    carregaProdutos();
  }, []);

  async function handleDelete(produto: ProdutoModel) {
    if (!produto) return;

    async function checkExistePartesProduto(): Promise<{
      existePartes: boolean;
      tamanho: number;
    }> {
      const response = await api.get(`/produto/${produto.id}/partes`);
      const existePartes = !!response.data.length;
      return { existePartes, tamanho: response.data.length };
    }

    const { existePartes, tamanho } = await checkExistePartesProduto();

    if (existePartes) {
      Swal.fire({
        icon: 'error',
        title: 'Ops!',
        html: ` <h4 className="heading mt-4">
                Não é possível remover o produto!
              </h4>
              <p>
                Esse produto possui
                ${tamanho} ${
          tamanho > 1 ? 'partes cadastradas.' : 'parte cadastrada.'
        }
                ${
                  tamanho > 1 ? 'remova-as' : 'remova-a'
                } para prosseguir com a exclusão.
              </p>`,
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonColor: '#d33',
        cancelButtonText: `Fechar`,
      });
    } else {
      Swal.fire({
        title: `Deseja excluir o produto ${produto.nome}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: `Sim, excluir`,
        confirmButtonColor: '#d33',
        cancelButtonText: `Não`,
      }).then(async result => {
        if (result.isConfirmed) {
          await api.delete(`/produto/${produto.id}`);
          carregaProdutos();
          Swal.close();
          toast.success('Registro excluído');
        }
      });
    }
  }

  async function comprimeImagem(imagem: string | null): Promise<string> {
    if (!imagem) {
      return '';
    }
    const compress = new Compress();
    const file = Compress.convertBase64ToFile(imagem?.split('base64,')[1]);
    const fileCompressed = await compress.compress([file], {
      quality: 0.7,
      maxWidth: 600,
      maxHeight: 640,
      resize: true,
    });
    return fileCompressed[0].data;
  }

  async function pegaProdutosAssociados(produtoId: number) {
    const response = await api.get(`/produto/produtos-associados/${produtoId}`);
    setProdutosAssociadosIniciais(response.data);
    const prodAssociados: ProdutoAssociado[] = response.data;
    const options = prodAssociados.map(prod => ({
      label: prod.produtoRelacao.nome,
      value: prod.produtoRelacao.id,
    }));
    setProdutosAssociados({
      ...produtosSelecao,
      options: options.map(item => {
        return {
          label: item.label,
          value: item.value,
        };
      }),
    });
  }

  function handleOpenModalEdicaoProduto(produto: ProdutoModel) {
    pegaProdutosAssociados(produto.id);
    setProdutoEditing(produto);
    setFormModalState(!formModalState);
    setProdutosSelecao(produtos.filter(prod => prod.id !== produto.id));
  }

  async function handleUpdateProduto() {
    setIsLoading(true);
    toast.loading('Salvando...', { position: 'top-center' });
    const {
      nome,
      codigoEmpresa,
      produtoCategoriaId,
      nomeProposta,
      bloquearProdutosDiferentes,
      geraGnf,
      geraPS,
      geraPedido,
      opcaoMostrarBotoes,
      permiteFatDireto,
    } = produtoEditing;
    if (!nome || !codigoEmpresa || !produtoCategoriaId) {
      return;
    }
    await api.put(`/produto/${produtoEditing.id}`, {
      nome,
      codigoEmpresa,
      produtoCategoriaId,
      nomeProposta,
      bloquearProdutosDiferentes,
      geraGnf,
      geraPS,
      geraPedido,
      opcaoMostrarBotoes,
      produtoPrincipalId: produtoEditing.id,
      produtosARelacionar: produtosAssociados.options,
      finame: produtoEditing.finame,
      setorAtividade: produtoEditing.setorAtividade,
      pepTemplate: produtoEditing.pepTemplate,
      ncm: produtoEditing.ncm,
      produtosAssociadosIniciais,
      permiteFatDireto,
    });

    setFormModalState(false);
    setProdutoEditing({} as ProdutoModel);
    carregaProdutos();
    setIsLoading(false);
    toast.dismiss();
    toast.success('Produto salvo');
  }

  function InputSelectProdutoCategoria(): JSX.Element {
    return (
      <Input
        placeholder="Categoria"
        type="select"
        value={produtoEditing.produtoCategoriaId || ''}
        onChange={text =>
          setProdutoEditing({
            ...produtoEditing,
            produtoCategoriaId: Number(text.target.value),
          })
        }
      >
        <option value="">Categoria...</option>
        {produtoCategorias.map(produtoCategoria => (
          <option value={produtoCategoria.id}>
            {produtoCategoria.descricao}
          </option>
        ))}
      </Input>
    );
  }

  function InputSelectPermiteBotoes(): JSX.Element {
    return (
      <Input
        placeholder="Mostrar nas telas"
        type="select"
        value={produtoEditing.opcaoMostrarBotoes || ''}
        onChange={text =>
          setProdutoEditing({
            ...produtoEditing,
            opcaoMostrarBotoes: Number(text.target.value),
          })
        }
      >
        {OpcaoMostrarBotoes.map(op => (
          <option value={op.id}>{op.label}</option>
        ))}
      </Input>
    );
  }

  useEffect(() => {
    if (produtoSelecionado) {
      setExibirModalImagem(true);
    }
  }, [produtoSelecionado]);

  function closeModalImagem() {
    setExibirModalImagem(!exibirModalImagem);
    setProdutoSelecionado(undefined);
  }

  async function salvarImagem(imagem: string | null) {
    // if (!produtoSelecionado?.id) return;
    try {
      setLoading(true);
      const imagemComprimida = await comprimeImagem(imagem);
      await api.put(`/produto/imagem`, {
        id: produtoSelecionado?.id,
        imagem: imagemComprimida || null,
        nome: produtoSelecionado?.nome,
      });
    } finally {
      setLoading(false);
      closeModalImagem();
    }
    carregaProdutos();
  }

  return (
    <Row>
      <div className="col">
        <ModalUploadImagem
          isOpen={exibirModalImagem}
          toggle={closeModalImagem}
          onSave={salvarImagem}
          imagem={produtoEditing?.imagem || ''}
          descricao={produtoSelecionado?.nome || ''}
        />

        {/* Modal edição */}
        <Modal
          className="modal-dialog-centered"
          size="lg"
          isOpen={formModalState}
          toggle={() => setFormModalState(!formModalState)}
        >
          <div className="modal-body p-0">
            <Card className="bg-secondary shadow border-0">
              <CardBody className="px-lg-5 py-lg-5">
                <div className="text-center text-muted mb-4">
                  <small>Produto {produtoEditing.nome}</small>
                </div>
                <Form role="form">
                  <FormGroup className="mb-3">
                    <Row>
                      <Col>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="ni ni-tag" />
                            </InputGroupText>
                          </InputGroupAddon>

                          <Input
                            placeholder="Nome do produto"
                            value={produtoEditing.nome}
                            type="text"
                            onChange={text =>
                              setProdutoEditing({
                                ...produtoEditing,
                                nome: text.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </Col>
                      <Col>
                        <InputGroup className="input-group-alternative">
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <FaBuilding />
                            </InputGroupText>
                          </InputGroupAddon>

                          <Input
                            placeholder="Código da empresa"
                            min="0"
                            value={produtoEditing.codigoEmpresa ?? ''}
                            type="number"
                            onChange={text =>
                              setProdutoEditing({
                                ...produtoEditing,
                                codigoEmpresa: String(text.target.value),
                              })
                            }
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-tag" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Tooltip title="Descrição do produto na proposta">
                        <Input
                          placeholder="Descrição do produto na proposta"
                          value={
                            produtoEditing.nomeProposta ?? produtoEditing.nome
                          }
                          type="text"
                          onChange={text =>
                            setProdutoEditing({
                              ...produtoEditing,
                              nomeProposta: text.target.value,
                            })
                          }
                        />
                      </Tooltip>
                    </InputGroup>
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Row>
                      <Col>
                        <InputGroup className="input-group-alternative">
                          <Input
                            placeholder="Finame"
                            value={produtoEditing?.finame ?? ''}
                            type="text"
                            onChange={text =>
                              setProdutoEditing({
                                ...produtoEditing,
                                finame: text.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </Col>
                      <Col>
                        <InputGroup className="input-group-alternative">
                          <Input
                            placeholder="Ncm"
                            value={produtoEditing.ncm ?? ''}
                            type="text"
                            onChange={text =>
                              setProdutoEditing({
                                ...produtoEditing,
                                ncm: text.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                  </FormGroup>

                  <Row>
                    <Col>
                      <FormGroup className="mt-3">
                        <InputGroup className="input-group-alternative">
                          <Input
                            placeholder="Setor de Atividade"
                            value={produtoEditing?.setorAtividade ?? ''}
                            type="text"
                            maxLength={2}
                            onChange={text =>
                              setProdutoEditing({
                                ...produtoEditing,
                                setorAtividade: text.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>
                      {/* </Col>
                    <Col> */}
                    </Col>
                    <Col>
                      <InputGroupAddon className="mt-3" addonType="append">
                        <InputSelectProdutoCategoria />
                      </InputGroupAddon>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup className="mt-3">
                        <InputGroup className="input-group-alternative">
                          <Input
                            placeholder="Template subprojeto"
                            value={produtoEditing?.pepTemplate ?? ''}
                            type="text"
                            maxLength={2}
                            onChange={text =>
                              setProdutoEditing({
                                ...produtoEditing,
                                pepTemplate: text.target.value,
                              })
                            }
                          />
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup className="mt-3 d-flex">
                        <InputGroup className="input-group-alternative justify-content-left  p-2 d-flex align-items-center">
                          <Tooltip title="Bloqueia o uso de produtos diferentes">
                            <strong className="h5 mb-0 mr-2">
                              Bloqueia produtos diferentes
                            </strong>
                          </Tooltip>
                          <label className="custom-toggle">
                            <input
                              type="checkbox"
                              onChange={() =>
                                setProdutoEditing({
                                  ...produtoEditing,
                                  bloquearProdutosDiferentes:
                                    !produtoEditing.bloquearProdutosDiferentes,
                                })
                              }
                              checked={
                                produtoEditing.bloquearProdutosDiferentes
                              }
                            />
                            <span
                              className="custom-toggle-slider rounded-circle"
                              placeholder="teste"
                            />
                          </label>
                        </InputGroup>
                        <InputGroup className="input-group-alternative justify-content-left mr-4 p-2 d-flex align-items-center">
                          <Tooltip title="Bloqueia o uso de produtos diferentes">
                            <strong className="h5 mb-0 mr-2">
                              Permite faturamento direto
                            </strong>
                          </Tooltip>
                          <label className="custom-toggle">
                            <input
                              type="checkbox"
                              onChange={() =>
                                setProdutoEditing({
                                  ...produtoEditing,
                                  permiteFatDireto:
                                    !produtoEditing.permiteFatDireto,
                                })
                              }
                              checked={produtoEditing.permiteFatDireto}
                            />
                            <span
                              className="custom-toggle-slider rounded-circle"
                              placeholder="teste"
                            />
                          </label>
                        </InputGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <FormGroup className="mt-3">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              className="mr-1 float-center"
                              checked={produtoEditing.geraGnf}
                              title="Gerar GNF"
                              onChange={event => {
                                setProdutoEditing({
                                  ...produtoEditing,
                                  geraGnf: event.target.checked,
                                  geraPedido: false,
                                  geraPS: false,
                                });
                              }}
                            />
                          }
                          label="Gerar GNF"
                        />

                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              className="mr-1 float-center"
                              checked={produtoEditing.geraPedido}
                              title="Gerar Pedido"
                              onChange={event => {
                                setProdutoEditing({
                                  ...produtoEditing,
                                  geraPedido: event.target.checked,
                                  geraGnf: false,
                                  geraPS: false,
                                });
                              }}
                            />
                          }
                          label="Gerar Pedido"
                        />

                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              className="mr-1 float-center"
                              checked={produtoEditing.geraPS}
                              title="Gerar PS"
                              onChange={event => {
                                setProdutoEditing({
                                  ...produtoEditing,
                                  geraPS: event.target.checked,
                                  geraPedido: false,
                                  geraGnf: false,
                                });
                              }}
                            />
                          }
                          label="Gerar PS"
                        />
                      </FormGroup>
                      {/* </Col>
                    <Col> */}
                    </Col>
                  </Row>

                  <FormGroup className="col-sm-14">
                    <small>
                      Produtos para composição de sistema:{' '}
                      <Tooltip
                        title={
                          <Label size="lg">
                            Os produtos selecionados neste campo determinam as
                            regras de precificação para o produto em questão.
                            Caso estejam na mesma proposta, ambos serão
                            precificados conforme produtos selecionados que irão
                            compor um sistema.
                          </Label>
                        }
                        placement="top"
                        arrow
                      >
                        <IconButton>
                          <FaInfoCircle size={12} color="#888787" />
                        </IconButton>
                      </Tooltip>
                    </small>
                    <Select
                      closeMenuOnSelect={false}
                      placeholder="Selecione..."
                      isMulti
                      options={produtosSelecao.map(item => {
                        return { label: item.nome, value: item.id };
                      })}
                      onChange={(e: any) => {
                        setProdutosAssociados({
                          ...produtosAssociados,
                          options: [...e],
                        });
                      }}
                      value={produtosAssociados.options}
                    />
                  </FormGroup>

                  <InputGroupAddon className="mt-3" addonType="append">
                    <InputSelectPermiteBotoes />
                  </InputGroupAddon>

                  <div className="text-center">
                    <Button
                      className="my-4"
                      disabled={
                        !produtoEditing.nome ||
                        !produtoEditing.codigoEmpresa ||
                        !produtoEditing.produtoCategoriaId ||
                        isLoading
                      }
                      color="primary"
                      type="button"
                      onClick={handleUpdateProduto}
                    >
                      Salvar
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Modal>

        <Card className="shadow">
          <CardHeader className="border-0">
            <h3 className="mb-0">Lista de produtos</h3>
          </CardHeader>
          <Table className="align-items-center table-flush" responsive>
            <tbody>
              {produtos.map(produto => (
                <tr key={produto.id}>
                  <td className="col">
                    <strong>{produto.nome}</strong>
                  </td>
                  <td>
                    <strong className="text-muted">
                      {produto?.ProdutoCategoria?.descricao}
                    </strong>
                  </td>
                  <td className="col">
                    <strong>
                      {produto.codigoEmpresa
                        ? `Empresa ${produto.codigoEmpresa}`
                        : ''}
                    </strong>
                  </td>
                  <td>
                    <Link
                      style={{ marginRight: '0.8rem' }}
                      to={{
                        pathname: `/admin/variaveis-regras`,
                        state: { produto },
                      }}
                    >
                      <Button size="sm" color="info">
                        Variáveis
                      </Button>
                    </Link>
                  </td>
                  <td>
                    <Link
                      style={{ marginRight: '0.8rem' }}
                      to={{
                        pathname: `/admin/atividades`,
                        state: { produto },
                      }}
                    >
                      <Button
                        size="sm"
                        style={{
                          background: '#447D9B',
                          borderColor: '#447D9B',
                          color: '#fff',
                        }}
                      >
                        Atividade
                      </Button>
                    </Link>
                  </td>
                  <td>
                    <Link
                      style={{ marginRight: '0.8rem' }}
                      to={{
                        pathname: `/admin/grupo-regras`,
                        state: { produto },
                      }}
                    >
                      <Button size="sm" color="default">
                        Regras
                      </Button>
                    </Link>
                  </td>
                  <td style={{ margin: 'none' }}>
                    <Link
                      to={{
                        pathname: `/admin/produto-partes`,
                        state: { produto },
                      }}
                    >
                      <Button
                        size="sm"
                        className="btn-icon"
                        color="primary"
                        type="button"
                      >
                        <span>Partes</span>
                      </Button>
                    </Link>
                  </td>
                  <td>
                    <Button
                      size="sm"
                      className="btn-icon"
                      color="warning"
                      type="button"
                      onClick={() => {
                        handleOpenModalEdicaoProduto(produto);
                      }}
                    >
                      <FaEdit />
                    </Button>
                  </td>
                  <td>
                    <Button
                      size="sm"
                      className="btn-icon"
                      color="default"
                      type="button"
                      onClick={() => {
                        setExibirModalImagem(true);
                        setProdutoSelecionado(produto);
                        setProdutoEditing({
                          ...produtoEditing,
                          imagem: produto?.imagem,
                        });
                      }}
                    >
                      <FaCamera />
                    </Button>
                  </td>
                  <td>
                    <Button
                      size="sm"
                      className="btn-icon"
                      color="danger"
                      type="button"
                      onClick={() => {
                        handleDelete(produto);
                      }}
                    >
                      <FaTimesCircle />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card>
      </div>
    </Row>
  );
}
